import clamp from 'lodash/clamp';

import { Point } from '@app/features/apply-react-signing/components/FieldRenderer/types';

export function clampFieldPoint(position: Point): Point {
  return {
    x: clamp(position.x, 0, 1),
    y: clamp(position.y, 0, 1),
  };
}
